import { render } from "./PersonalData.vue?vue&type=template&id=1969dba4&ts=true"
import script from "./PersonalData.vue?vue&type=script&lang=ts"
export * from "./PersonalData.vue?vue&type=script&lang=ts"

import "./PersonalData.vue?vue&type=style&index=0&id=1969dba4&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__